import { root } from './publish';

export const publish = {
  ...root,
};
